import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectEmailLanguage = createSelector(
  (state: GlobalState) => state.generateCodeRequestDetails,
  (details) => details.partnerEmail?.language,
);

export const selectIsTermsAndConditionAccepted = createSelector(
  (state: GlobalState) => state.generateCodeRequestDetails,
  (details) => details.termsAndCondition,
);

export const selectGenerateCodeDetails = createSelector(
  (state: GlobalState) => state.generateCodeRequestDetails,
  (detail) => detail,
);
